










import { Component, Vue } from "@/shared/node_modules/vue-property-decorator";
import EmbeddedActions from "@/shared/components/embeddedActions/embeddedActions.vue";
import LoginRegisterDialog from "@/shared/components/login/loginRegisterDialog.vue";
import { applyBrandTheme } from "@/shared/core/helpers/brandHelper";
import { notifyResize } from "@/shared/core/embed";
import store from "@/shared/core/store";

@Component({
  components: {
    EmbeddedActions,
    LoginRegisterDialog,
  },
})
export default class EmbeddedLayout extends Vue {
  private resizeObserver: any = null;
  private rafId: any = null;
  private lastSent = 0;

  mounted() {
    applyBrandTheme(store.state.settings);
    this.sendHeight();
    // Avisar al host de cada cambio de altura para que ajuste el iframe sin scroll propio.
    if (typeof (window as any).ResizeObserver !== "undefined") {
      this.resizeObserver = new (window as any).ResizeObserver(() => this.sendHeight());
      this.resizeObserver.observe(document.body);
    } else {
      window.addEventListener("resize", this.sendHeight);
    }
  }

  beforeDestroy() {
    if (this.rafId) {
      cancelAnimationFrame(this.rafId);
    }
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    } else {
      window.removeEventListener("resize", this.sendHeight);
    }
  }

  // Coalesce bursts with rAF, only notify on real change, and clamp as a safety net so a
  // viewport-height feedback loop can never report an absurd height.
  sendHeight() {
    if (this.rafId) {
      return;
    }
    this.rafId = requestAnimationFrame(() => {
      this.rafId = null;
      const height = Math.min(document.body.scrollHeight, 50000);
      if (Math.abs(height - this.lastSent) < 2) {
        return;
      }
      this.lastSent = height;
      notifyResize(height);
    });
  }
}
